import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class MetaTagService {
  constructor(private metaService: Meta, private titleService: Title) {}
  
  updateMetaTags(meta: any): void {
    Object.keys(meta).forEach((key) => {
      const content = meta[key];

      if (key === 'title') {        
        this.titleService.setTitle(content);
      } else if (key.startsWith('og:') || key.startsWith('twitter:')) {        
        this.metaService.updateTag({ property: key, content: content });
      } else {        
        this.metaService.updateTag({ name: key, content: content });
      }
    });
  }
}
